/* eslint-disable react/jsx-key */
import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { RoutedModal, WarningDialog } from "../../../common";
import { ExpenseDepartmentForm } from "../ExpenseDepartmentForm";
import { useExpenseDepartmentsTable } from "./useExpenseCategoryTable";

export const ExpenseDepartmentsTable = ({
  expenseDepartments = [],
  metaDetails,
  gotoPage = () => {},
}) => {
  const {
    instance,
    isDeleteDepartment,
    isEditDepartment,
    isDeletingDepartment,
    handleDeleteDepartment,
    setIsDeleteDepartment,
    setIsEditDepartment,
  } = useExpenseDepartmentsTable({
    expenseDepartments,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAc
      >
        <div className="text-center my-5">
          <img src={Images.expenseEmptyState} width="250px" alt="" />
          <h4 className="mt-4">You have no expense departments</h4>
          <p className="text-center">
            Use the button above to add your departments. When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {expenseDepartments?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      {/*  Update Expense Department */}
      <RoutedModal
        isActive={isEditDepartment !== null}
        headerTitle="Update Department"
        width={550}
        style={{ height: "auto" }}
        closeModal={() => setIsEditDepartment(null)}
      >
        <ExpenseDepartmentForm
          closeModal={() => setIsEditDepartment(null)}
          isEditMode={true}
          departmentDetails={isEditDepartment}
        />
      </RoutedModal>

      {/* delete modal */}
      <secondaryComponents.Modal
        isActive={!!isDeleteDepartment}
        width={550}
        closeModal={() => setIsDeleteDepartment(null)}
      >
        <WarningDialog
          title={`Delete Department: ${isDeleteDepartment?.id}`}
          closeModal={() => setIsDeleteDepartment(null)}
          handler={() => handleDeleteDepartment()}
          isLoading={isDeletingDepartment}
        >
          <p>
            Name: <span className="dark--text">{isDeleteDepartment?.name}</span>
          </p>
        </WarningDialog>
      </secondaryComponents.Modal>
    </>
  );
};
